import DOMPurify from 'dompurify';

export function sanitizeRichText(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'strike', 'a',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'blockquote', 'pre', 'code', 'hr'],
    ALLOWED_ATTR: ['href', 'rel', 'start'],
    ALLOW_DATA_ATTR: false,
  });
}

export function hasRichTextContent(html: string): boolean {
  const document = new DOMParser().parseFromString(sanitizeRichText(html), 'text/html');
  return Boolean(document.body.textContent?.trim());
}
